import { render, staticRenderFns } from "./InventoryStatsRow.vue?vue&type=template&id=716ff641&scoped=true"
import script from "./InventoryStatsRow.vue?vue&type=script&lang=js"
export * from "./InventoryStatsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ff641",
  null
  
)

export default component.exports